import React from 'react';
import Checkbox from 'Common/Components/Checkbox';
import { Label, CheckboxWrapper } from './styled';
import { capitalize } from 'lodash';

const BooleanField = ({ defaultValue, param = '', onChange, disabled }) => {
  const text = capitalize(param.replace('_', ' '));

  return (
    <CheckboxWrapper key={ param } >
      <Checkbox state={ defaultValue } onChange={ (e) => onChange(!e.currentTarget.checked) } disabled={ disabled } />
      <Label children={ text } disabled={ disabled } />
    </CheckboxWrapper>
  );
};
export default BooleanField;
